export const psqiCardData = [
  { title: "Puntuación Global", dataKey: "puntuacionGlobal" },
  { title: "Calidad subjetiva del sueño", dataKey: "calidadDelSueno" },
  { title: "Latencia de sueño", dataKey: "latenciaDelSueno" },
  { title: "Duración del sueño", dataKey: "duraciónDelSueno" },
  { title: "Eficiencia habitual del sueño", dataKey: "eficienciaDelSueno" },
  { title: "Alteraciones del sueño", dataKey: "despertaresNocturnos" },
  { title: "Uso de medicación para dormir", dataKey: "usoDeMedicamentos" },
  { title: "Disfunción diurna", dataKey: "disfunciónDiurna" },
];
